module.exports = __webpack_public_path__ + "static/media/plaque_raon22.8551aee1.png";